import { useCreateReviewedFactor } from "@/modules/reviews/useCreateReviewedFactor";
import {
  AppointmentQueueListParams,
  SnappPayEligibilityCommand,
} from "@/models/club";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getAllAppointmentQueue,
  checkSnappPayEligibility,
  resendPaymentLinkSms,
  retryPurchase,
  inquirePurchasePayment,
} from ".";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

const useCreateFactor = useCreateReviewedFactor;

const useGetAllAppointmentQueue = (params: AppointmentQueueListParams) =>
  useQuery({
    queryKey: [
      "get-shift-schedule",
      params?.AppointmentDateFrom,
      params?.AppointmentDateTo,
      params?.CustomerId,
    ],
    queryFn: () => getAllAppointmentQueue(params),
    select: (res) => res,
    enabled: false,
  });

const useCheckSnappPayEligibility = () =>
  useMutation({
    mutationFn: (data: SnappPayEligibilityCommand) =>
      checkSnappPayEligibility(data),
  });

const useResendPaymentLinkSms = () =>
  useMutation({
    mutationFn: (purchaseId: number) => resendPaymentLinkSms(purchaseId),
    onSuccess: () => {
      notifications.show({
        message: "پیامک لینک پرداخت مجدداً برای مشتری ارسال شد",
        color: "green",
      });
    },
  });

const useRetryPurchase = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (purchaseId: number) => retryPurchase(purchaseId),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      notifications.show({
        title: `فاکتور جدید #${result.purchaseId || ""}`,
        message: "تلاش مجدد ثبت و لینک پرداخت جدید برای مشتری پیامک شد",
        color: "green",
      });
    },
  });
};

const useInquirePurchasePayment = (purchaseId?: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (transactionId: string) => inquirePurchasePayment(transactionId),
    onSuccess: (result) => {
      notifications.show({
        message: result.message || (result.isSuccess ? "پرداخت با موفقیت انجام شد" : "پرداخت ناموفق بود"),
        color: result.isSuccess ? "green" : "red",
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      notifications.show({
        title: "وضعیت پرداخت هنوز مشخص نیست",
        message: error.response?.data?.message || "ارتباط با اسنپ‌پی برقرار نشد. کمی بعد دوباره استعلام کنید.",
        color: "yellow",
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["invoice-detail", purchaseId] });
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
};

export {
  useCreateFactor,
  useGetAllAppointmentQueue,
  useCheckSnappPayEligibility,
  useResendPaymentLinkSms,
  useRetryPurchase,
  useInquirePurchasePayment,
};
